import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PAComponiFatturaConfirmComponent } from './pa-componi-fattura-confirm';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pa-componi-fattura-confirm', {
            url: '/pa-componi-fattura-confirm',
            ncyBreadcrumb: {
                label: 'Componi Fattura Conferma',
                parent: 'home.fatturazione-pa'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Componi Fattura Conferma'
            },
            'views': {
                'homeContent': {
                    template: '<pa-componi-fattura-confirm flex="100"></pa-componi-fattura-confirm>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PAComponiFatturaConfirmModule: string = ng
    .module('pa-componi-fattura-confirm', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('paComponiFatturaConfirm', PAComponiFatturaConfirmComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-componi-fattura-confirm/pa-componi-fattura-confirm.module.ts